export default "/_next/static/images/9c0182667c177f6192dcfbc2ea29303c.jpg";